import _styled from "@emotion/styled-base";
/* eslint-disable id-blacklist, no-restricted-imports */
import { css } from '@emotion/core';
import { variables as vars, media } from '@domain-group/fe-brary';
import { headlineWrap, ellipsis } from '../../style/shared.style';
var font = vars.font;
var commercialPriceFontSize = '20px';
export var Identifier = _styled("div", {
  target: "e9vzjw50"
})("font-family:", font.headingFontFamily, ";");
export var Headline = _styled("div", {
  target: "e9vzjw51"
})(headlineWrap, ";", ellipsis(2, font.h3LineHeight), ";font-size:", font.h3FontSize, ";line-height:", font.h3LineHeight, ";font-weight:", font.headingFontWeight, ";", media('>=desktop'), "{font-size:", font.h2FontSize, ";line-height:", font.h2LineHeight, ";", ellipsis(2, font.h2LineHeight), ";}");
export var ResidentialPrice = _styled("div", {
  target: "e9vzjw52"
})(headlineWrap, ";", ellipsis(2, font.h3LineHeight), ";font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", font.h3FontSize, ";line-height:", font.h3LineHeight, ";", media('>=desktop'), "{font-size:", font.h2FontSize, ";line-height:", font.h2LineHeight, ";", ellipsis(2, font.h2LineHeight), ";}");
export var NonResidentialPrice = /*#__PURE__*/_styled(ResidentialPrice, {
  target: "e9vzjw53"
})("font-size:", font.h4MobileFontSize, ";line-height:", font.h4MobileLineHeight, ";", media('>=desktop'), "{font-size:", commercialPriceFontSize, ";max-width:none;}");
export var ResidentialAddress = _styled("h1", {
  target: "e9vzjw54"
})("font-size:", font.baseFontSize, ";line-height:", font.smallLineHeight, ";margin-top:0;.address,.address-body{display:inline;}", media('>=desktop'), "{margin-top:4px;font-size:", font.h4FontSize, ";line-height:", font.baseLineHeight, ";font-weight:", font.headingFontWeight, ";}");
export var NonResidentialAddress = /*#__PURE__*/_styled(ResidentialAddress, {
  target: "e9vzjw55"
})("margin-bottom:16px;", media('>=tablet'), "{line-height:", font.baseLineHeight, ";}", media('>=desktop'), "{margin-bottom:24px;}");
export var OffMarketAddress = _styled("h1", {
  target: "e9vzjw56"
})(headlineWrap, ";font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", font.h3FontSize, ";line-height:", font.h3LineHeight, ";", media('>=desktop'), "{font-size:", font.h2FontSize, ";line-height:", font.h2LineHeight, ";}");
export var addressWrap = /*#__PURE__*/css(headlineWrap, ";");
export var Header = _styled("div", {
  target: "e9vzjw57"
})({
  name: "k008qs",
  styles: "display:flex;"
});
export var agencyLogo = {
  name: "1621hb",
  styles: "display:block;width:100%;margin-bottom:8px;cursor:pointer;"
};
export var agencyLogoContainer = /*#__PURE__*/css("width:112px;margin-left:auto;margin-bottom:4px;padding-left:12px;flex-shrink:0;", media('>=tablet'), "{display:none;}");
export var headlineContainer = {
  name: "1iefgnt",
  styles: "margin-bottom:12px;width:100%;"
};
export var DevelopmentHeadline = _styled("h1", {
  target: "e9vzjw58"
})(headlineWrap, ";font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", font.h2FontSize, ";line-height:", font.h2LineHeight, ";");
export var developmentAddress = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";", media('>=desktop'), "{font-size:", font.h4FontSize, ";line-height:", font.baseLineHeight, ";}");
export var tagline = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:", font.baseMobileLineHeight, ";", media('>=desktop'), "{line-height:", font.baseLineHeight, ";}");
export var developmentPrice = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";margin-top:16px;", media('>=desktop'), "{font-size:", font.h4FontSize, ";line-height:", font.baseLineHeight, ";}");